<template>
  <div class="xiaoq-query-embed-wrap">
    <div v-if="loading" class="embed-loading">加载中...</div>
    <div v-else-if="loadError" class="embed-error">
      <p>{{ loadError }}</p>
      <el-button type="primary" size="small" @click="loadEmbedUrl(true)">重试</el-button>
    </div>
    <iframe
      v-else-if="embedUrl"
      :src="embedUrl"
      class="xiaoq-query-iframe"
      frameborder="0"
      allowfullscreen
    />
  </div>
</template>

<script>
import api from '@/api/index'
import { appendQuickBiLocaleToUrl } from '@/utils/util'

export default {
  name: 'XiaoQQueryEmbed',
  data() {
    return {
      initialized: false,
      loading: false,
      loadError: '',
      embedUrl: ''
    }
  },
  mounted() {
    this.loadEmbedUrl()
  },
  methods: {
    logOpenAction() {
      api.EarthLog.Log({
        UserName: this.$store.state.user.userName,
        FullName: this.$store.state.user.fullName,
        ActionType: 'QuickBI-xiaoQQuery',
        ClientType: 'PC',
        Content: '',
        CommentContent: ''
      })
    },

    loadEmbedUrl(force = false) {
      if (this.initialized && this.embedUrl && !force) {
        return
      }

      const userId = this.$store.state.user && this.$store.state.user.id
      if (!userId) {
        this.loadError = '未获取到当前用户信息，请重新登录'
        return
      }

      this.loading = true
      this.loadError = ''
      if (force) {
        this.embedUrl = ''
      }

      api.QuickBI.GetXiaoQQueryEmbedUrl(userId)
        .then((response) => {
          if (response && response.isSuccess && response.data && response.data.embedUrl) {
            const isFirstLoad = !this.initialized
            this.embedUrl = appendQuickBiLocaleToUrl(response.data.embedUrl)
            this.initialized = true
            if (isFirstLoad) {
              this.logOpenAction()
            }
          } else {
            this.loadError = (response && response.message) || '获取小Q问数嵌入链接失败'
          }
        })
        .catch(() => {
          this.loadError = '获取小Q问数嵌入链接失败，请稍后重试'
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.xiaoq-query-embed-wrap {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
}

.xiaoq-query-iframe {
  flex: 1;
  width: 100%;
  min-height: calc(100vh - 60px);
  border: none;
}

.embed-loading,
.embed-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 300px;
  color: #666;
}

.embed-error p {
  margin-bottom: 16px;
}
</style>
